/**
 * Der Fortschrittsbalken: x von n Prüfbereichen abgeschlossen.
 *
 * Immer mit Zahl daneben. Ein Balken allein sagt „ungefähr die Hälfte";
 * der Beirat will wissen, welche Hälfte — darum stehen die Schritte darunter.
 */

export function Fortschritt({
  anteil,
  text,
  gross = false,
}: {
  /** 0 bis 1. */
  anteil: number;
  /** Rechts daneben, z. B. „2 von 5 Prüfbereichen". */
  text?: string;
  gross?: boolean;
}) {
  const prozent = Math.round(Math.max(0, Math.min(1, anteil)) * 100);
  return (
    <div className={`fortschritt${gross ? ' gross' : ''}`} role="progressbar" aria-valuenow={prozent} aria-valuemin={0} aria-valuemax={100}>
      <div className="fortschritt-bahn">
        <div className={`fortschritt-wert${prozent === 100 ? ' voll' : ''}`} style={{ width: `${prozent}%` }} />
      </div>
      <div className="fortschritt-text">
        <b>{prozent} %</b>
        {text && <span>{text}</span>}
      </div>
    </div>
  );
}
